import { RouterPaths } from "../app/appConstants";

export const MobileRouterPaths = {
    academy: '/academy',
    auth: '/auth',
    brokenLink: '/broken-link',
    cashier: '/cashier',
    chooseAccountType: '/choose-account-type',
    confirm: '/confirm',
    contacts: '/contacts',
    default: '/',
    firstStart: '/first-start',
    forgot: '/forgot',
    login: '/login',
    leaderboard: '/leaderboard',
    leaderboardOnboarding: '/leaderboard-onboarding',
    market: '/market',
    marketInner: '/market-inner',
    partnerPublicDocs: '/docs-affiliate-program',
    portfolio: '/portfolio',
    portfolioInner: '/portfolio-inner',
    privacyPolicy: '/privacy-policy',
    profile: '/profile',
    profileInner: '/profile-inner',
    promotions: '/promotions',
    registration: '/registration',
    reset: '/reset',
    referralAmazing: '/referral-amazing',
    support: '/support'
} as const;

export const MAP_MOBILE_TO_WEB_ROUTE = {
    [MobileRouterPaths.forgot]: RouterPaths.forgot,
}

export const SOCKET_TYPE_MESSAGES = {
    ACCOUNT_EVENTS_OPEN: 'AccountEventsSubscriptionRequest' as const,
    ACCOUNT_EVENTS_CLOSE: 'AccountEventsCloseSubscriptionRequest' as const,
    ACCOUNT_METRICS_OPEN: 'AccountMetricsSubscriptionRequest' as const,
    ACCOUNT_METRICS_CLOSE: 'AccountMetricsCloseSubscriptionRequest' as const,
    ACCOUNT_PORTFOLIOS_OPEN: 'AccountPortfoliosSubscriptionRequest' as const,
    ACCOUNT_PORTFOLIOS_CLOSE: 'AccountPortfoliosCloseSubscriptionRequest' as const,
    MARKET_DATA_OPEN: 'MarketDataSubscriptionRequest' as const,
    MARKET_DATA_CLOSE: 'MarketDataCloseSubscriptionRequest' as const,
} as const;

export const oppositeSubscriptionName = {
    [SOCKET_TYPE_MESSAGES.ACCOUNT_EVENTS_OPEN]: SOCKET_TYPE_MESSAGES.ACCOUNT_EVENTS_CLOSE,
    [SOCKET_TYPE_MESSAGES.ACCOUNT_METRICS_OPEN]: SOCKET_TYPE_MESSAGES.ACCOUNT_METRICS_CLOSE,
    [SOCKET_TYPE_MESSAGES.ACCOUNT_PORTFOLIOS_OPEN]: SOCKET_TYPE_MESSAGES.ACCOUNT_PORTFOLIOS_CLOSE,
    [SOCKET_TYPE_MESSAGES.MARKET_DATA_OPEN]: SOCKET_TYPE_MESSAGES.MARKET_DATA_CLOSE,
}

export const LIST_TO_BUY = [
    'EURUSD' as const,
    'GBPUSD' as const,
    'XAUUSD' as const,
    'USDCHF' as const,
    'USDJPY' as const,
    'USDCAD' as const,
    'AUDUSD' as const,
    'NZDUSD' as const,
    'GBPJPY' as const,
    'EURJPY' as const,
    'EURAUD' as const,
    'GBPNZD' as const,
    'EURCHF' as const,
    'EURGBP' as const,
    'EURNZD' as const,
    'ETHUSD' as const,
    'BTCUSD' as const,
    'AAPL' as const,
    'TSLA' as const,
    'WTIUSD' as const,
    'BRNUSD' as const,
    'SPXUSD' as const,
] as const;

export const OPEN_MOBILE_SLIDER_PAGE = 'OPEN_MOBILE_SLIDER_PAGE' as const;
export const CLOSE_MOBILE_SLIDER_PAGE = 'CLOSE_MOBILE_SLIDER_PAGE' as const;
export const ADD_MOBILE_SLIDER_PAGE = 'ADD_MOBILE_SLIDER_PAGE' as const;

export const REGISTRATION_PREPARE_MOBILE_ACTION = 'REGISTRATION_PREPARE_MOBILE_ACTION' as const;
export const REGISTRATION_START_MOBILE_ACTION = 'REGISTRATION_START_MOBILE_ACTION' as const;

export const AUTH_REGISTER_MOBILE_APP_ACTION = 'AUTH_REGISTER_MOBILE_APP_ACTION' as const;
export const AUTH_REGISTER_MOBILE_APP_SUCCESS = 'AUTH_REGISTER_MOBILE_APP_SUCCESS' as const;
export const AUTH_REGISTER_MOBILE_APP_FAILURE = 'AUTH_REGISTER_MOBILE_APP_FAILURE' as const;

export const AUTH_VERIFY_MOBILE_APP_ACTION = 'AUTH_VERIFY_MOBILE_APP_ACTION' as const;
export const AUTH_VERIFY_MOBILE_APP_SUCCESS = 'AUTH_VERIFY_MOBILE_APP_SUCCESS' as const;
export const AUTH_VERIFY_MOBILE_APP_FAILURE = 'AUTH_VERIFY_MOBILE_APP_FAILURE' as const;
